import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({ standalone: false, selector: 'tr',
})
export class TableRowEditHintDirective {
  private static tooltip: HTMLElement;
  private readonly enabled: boolean;

  constructor(elementRef: ElementRef<HTMLElement>, renderer: Renderer2) {
    if (elementRef.nativeElement.parentElement?.tagName.toLowerCase() !== 'tbody') return;
    const hasTooltipAttribute = elementRef.nativeElement.getAttributeNames().some((attribute) => attribute.includes('tooltip'));
    const isBonificaciones = globalThis.location?.hash?.includes('/bonificaciones');
    const hasOwnTableTooltip = isBonificaciones || elementRef.nativeElement.closest('.bonificaciones-page') !== null || hasTooltipAttribute;
    this.enabled = !hasOwnTableTooltip;
    if (hasOwnTableTooltip) {
      return;
    }
    renderer.addClass(elementRef.nativeElement, 'tw-cursor-pointer');
  }

  @HostListener('mouseenter', ['$event.currentTarget'])
  mostrarTooltip(target: EventTarget | null): void {
    const row = target instanceof HTMLElement ? target : null;
    if (!row) return;
    if (!this.enabled || row.parentElement?.tagName.toLowerCase() !== 'tbody') return;
    row.removeAttribute('title');
    TableRowEditHintDirective.tooltip?.remove();
    TableRowEditHintDirective.tooltip = document.createElement('span');
    TableRowEditHintDirective.tooltip.className = 'table-row-edit-tooltip';
    TableRowEditHintDirective.tooltip.textContent = 'Doble clic para editar';
    TableRowEditHintDirective.tooltip.style.position = 'fixed';
    TableRowEditHintDirective.tooltip.style.zIndex = '10000';
    TableRowEditHintDirective.tooltip.style.background = '#1f2937';
    TableRowEditHintDirective.tooltip.style.color = '#fff';
    TableRowEditHintDirective.tooltip.style.padding = '4px 8px';
    TableRowEditHintDirective.tooltip.style.borderRadius = '4px';
    TableRowEditHintDirective.tooltip.style.fontSize = '12px';
    TableRowEditHintDirective.tooltip.style.pointerEvents = 'none';
    document.body.appendChild(TableRowEditHintDirective.tooltip);
    const rect = row.getBoundingClientRect();
    const tooltipWidth = TableRowEditHintDirective.tooltip.getBoundingClientRect().width;
    TableRowEditHintDirective.tooltip.style.top = `${Math.max(4, rect.top + 8)}px`;
    TableRowEditHintDirective.tooltip.style.left = `${Math.max(4, rect.left - tooltipWidth - 8)}px`;
  }

  @HostListener('mouseleave')
  ocultarTooltip(): void {
    TableRowEditHintDirective.tooltip?.remove();
    TableRowEditHintDirective.tooltip = null;
  }
}
